import React from 'react'

const DocumentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M20.6284 14.0156H11.2949"
        stroke="url(#paint0_radial_4176_17411)"
        strokeWidth={1.33}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6284 18.0391H11.2949"
        stroke="url(#paint1_radial_4176_17411)"
        strokeWidth={1.33}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6284 22.0391H11.2949"
        stroke="url(#paint2_radial_4176_17411)"
        strokeWidth={1.33}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.64551 8.63714H12.6656V3.96875"
        stroke="url(#paint3_radial_4176_17411)"
        strokeWidth={1.33}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8054 3.34375C13.1268 3.34398 12.4706 3.58696 11.9554 4.02876L8.35037 7.12213C8.03945 7.38848 7.78995 7.71905 7.61904 8.09108C7.44814 8.4631 7.35988 8.86775 7.36035 9.27715V25.8974C7.36035 27.364 8.56037 28.5641 9.68038 28.5641H21.9739C23.7872 28.5641 24.6406 27.364 24.6406 25.8974V3.34375H13.8054Z"
        stroke="url(#paint4_radial_4176_17411)"
        strokeWidth={1.33}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <defs>
        <radialGradient
          id="paint0_radial_4176_17411"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22.9711 15.2776) rotate(-173.858) scale(13.7196 9.93041)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4176_17411"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22.9711 19.3011) rotate(-173.858) scale(13.7196 9.93041)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4176_17411"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22.9711 23.3011) rotate(-173.858) scale(13.7196 9.93041)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_4176_17411"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.9256 9.86026) rotate(-136.952) scale(10.0397 34.074)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_4176_17411"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.9779 35.1718) rotate(-124.299) scale(44.8168 141.946)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default DocumentIcon